import { useNFTMainData } from '@pkg/hooks';

import { type NFTDetailsDataTypes } from '@app/pages/NFTDetailView/components/Details/Details.data';

export const useNFTDetailsData = (): { data: Partial<NFTDetailsDataTypes> | undefined; isLoading: boolean } => {
    const { data, isLoading } = useNFTMainData();
    return { data, isLoading };
};
